var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ah-filter-group-badge",
      class: { active: _vm.activeCount > 0 },
      on: { click: _vm.handleClick }
    },
    [
      _c("div", { staticClass: "ah-filter-group-badge-label" }, [
        _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")
      ]),
      _vm._v(" "),
      _vm.activeCount > 0
        ? _c("div", { staticClass: "ah-filter-group-children-counter" }, [
            _vm._v("\n    " + _vm._s(_vm.activeCount) + "\n  ")
          ])
        : _c("div", { staticClass: "ah-filter-group-plus-icon-container" }, [
            _c("img", {
              staticClass: "ah-filter-group-plus-icon",
              attrs: { src: _vm.plusIconSrc, "aria-hidden": "true" }
            })
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }